import { useTranslation } from "react-i18next"

import { Cloud, GraduationCap, Loader2, ShieldCheck, Sparkles } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { HelloAILogo } from "@/components/ui/hello-ai-logo"

import { OnboardingWelcomeCard } from "./onboarding-page-components"

export function OnboardingWelcomeStep({
  busy,
  showM365Step,
  showTrainingStep,
  onStart,
}: {
  busy: boolean
  showM365Step: boolean
  showTrainingStep: boolean
  onStart: () => void
}) {
  const { t } = useTranslation()
  const cardCount = 2 + (showTrainingStep ? 1 : 0) + (showM365Step ? 1 : 0)
  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
      <HelloAILogo className="w-32 sm:w-40" />
      <h1
        data-onboarding-step-heading
        className="font-display mt-6 text-3xl font-semibold sm:text-4xl"
        tabIndex={-1}
      >
        {t("personalization.smoothOnboarding.welcome.title")}
      </h1>
      <p className="text-muted-foreground mt-3 max-w-xl text-base sm:text-lg">
        {t("personalization.smoothOnboarding.welcome.description")}
      </p>
      <div
        className={`mt-8 grid w-full gap-3 text-left ${
          cardCount === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2"
        }`}
      >
        <OnboardingWelcomeCard
          description={t("personalization.smoothOnboarding.welcome.compliance")}
          icon={ShieldCheck}
        />
        {showTrainingStep && (
          <OnboardingWelcomeCard
            description={t("personalization.smoothOnboarding.welcome.training")}
            icon={GraduationCap}
          />
        )}
        {showM365Step && (
          <OnboardingWelcomeCard
            description={t("personalization.smoothOnboarding.welcome.m365")}
            icon={Cloud}
          />
        )}
        <OnboardingWelcomeCard
          description={t("personalization.smoothOnboarding.welcome.personalization")}
          icon={Sparkles}
        />
      </div>
      <Button className="mt-8 min-h-11 min-w-48 px-6 text-base" disabled={busy} onClick={onStart}>
        {busy && <Loader2 aria-hidden="true" className="size-4 animate-spin" />}
        {t("personalization.smoothOnboarding.welcome.start")}
      </Button>
    </div>
  )
}
